import VacConfigProvider from "@vue-admin-core/components/config-provider";
import VacHeader from "@vue-admin-core/components/header";
import VacTableSelect from "@vue-admin-core/components/table-select";
import VacRichText from "@vue-admin-core/components/rich-text";
import VacMsgEditor from "@vue-admin-core/components/msg-editor";
import VacTree from "@vue-admin-core/components/tree";
import VacPagination from "@vue-admin-core/components/pagination";

export default [
  VacConfigProvider,
  VacHeader,
  VacTableSelect,
  VacRichText,
  VacMsgEditor,
  VacTree,
  VacPagination
];
